<!-- PhotoInput.vue -->
<template lang="pug">
div
  v-btn(v-if="button" fab color="#ff4081" @click="sheet = true")
    v-icon(color="#fff") mdi-camera

  div.photo-input-wrap(v-else @click="sheet = true")
    v-text-field.photo-input(
      :label="label"
      :value="display"
      prepend-icon="mdi-paperclip"
      readonly
      tabindex="-1"
    )

  v-bottom-sheet(v-model="sheet")
    v-sheet.pa-4
      .text-subtitle-1.mb-3 {{ label }}

      v-row(dense)
        v-col(cols="6")
          v-btn(block large outlined color="primary" @click="$refs.camera.click()")
            v-icon(left) mdi-camera
            | {{ shots.length ? 'Снять ещё' : 'Камера' }}
        v-col(cols="6")
          v-btn(block large outlined color="primary" @click="$refs.gallery.click()")
            v-icon(left) mdi-image-multiple
            | Галерея

      .d-flex.flex-wrap.mt-3(v-if="shots.length")
        .shot(v-for="(s, i) in shots" :key="s.url")
          img(:src="s.url")
          v-btn.shot__del(x-small icon @click="remove(i)")
            v-icon(small) mdi-close

      v-row.mt-2(dense v-if="shots.length")
        v-col(cols="6")
          v-btn(block text @click="sheet = false") Отмена
        v-col(cols="6")
          v-btn(block color="success" @click="finish(shots.map(s => s.file))") Готово ({{ shots.length }})

  input(ref="camera" type="file" accept="image/*" capture="environment" hidden @change="onCamera")
  input(ref="gallery" type="file" accept="image/*" :multiple="multiple" hidden @change="onGallery")
</template>

<script>
export default {
  props: {
    value: { default: () => [] },
    label: String,
    multiple: { type: Boolean, default: false },
    button: { type: Boolean, default: false }
  },

  data: () => ({ sheet: false, shots: [] }),

  watch: {
    sheet(open) { if (!open) this.clear() }
  },

  beforeDestroy() {
    this.clear()
  },

  computed: {
    display() {
      const v = this.value
      if (!v || (Array.isArray(v) && !v.length)) return ''
      return Array.isArray(v) ? `Выбрано: ${v.length}` : v.name
    }
  },

  methods: {
    onCamera(e) {
      const file = e.target.files[0]
      e.target.value = ''
      if (!file) return
      if (!this.multiple) return this.finish([file])
      this.shots.push({ file, url: URL.createObjectURL(file) })
    },

    onGallery(e) {
      const files = Array.from(e.target.files)
      e.target.value = ''
      if (!files.length) return
      this.finish(this.shots.map(s => s.file).concat(files))
    },

    remove(i) {
      URL.revokeObjectURL(this.shots[i].url)
      this.shots.splice(i, 1)
    },

    finish(files) {
      this.$emit('input', this.multiple ? files : files[0])
      this.sheet = false
    },

    clear() {
      this.shots.forEach(s => URL.revokeObjectURL(s.url))
      this.shots = []
    }
  }
}
</script>

<style scoped>
.photo-input-wrap { 
  cursor: pointer; 
}
.photo-input,
.photo-input >>> * { 
  pointer-events: none; 
}
.shot { 
  position: relative; 
  width: 72px; 
  height: 72px; 
  margin: 4px; 
}
.shot img { 
  width: 100%; 
  height: 100%; 
  object-fit: cover; 
  border-radius: 4px; 
}
.shot__del { 
  position: absolute; 
  top: 0; 
  right: 0; 
  background: rgba(255,255,255,.85); 
}
</style>